/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardOutcome } from './ScorecardOutcome.js';
import {
    ScorecardOutcomeFromJSON,
    ScorecardOutcomeFromJSONTyped,
    ScorecardOutcomeToJSON,
} from './ScorecardOutcome.js';
import type { ScorecardStatus } from './ScorecardStatus.js';
import {
    ScorecardStatusFromJSON,
    ScorecardStatusFromJSONTyped,
    ScorecardStatusToJSON,
} from './ScorecardStatus.js';
import type { ScorecardTemplateSummary } from './ScorecardTemplateSummary.js';
import {
    ScorecardTemplateSummaryFromJSON,
    ScorecardTemplateSummaryFromJSONTyped,
    ScorecardTemplateSummaryToJSON,
} from './ScorecardTemplateSummary.js';

/**
 * 
 * @export
 * @interface Scorecard
 */
export interface Scorecard {
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    id?: number;
    /**
     * 
     * @type {ScorecardTemplateSummary}
     * @memberof Scorecard
     */
    template?: ScorecardTemplateSummary;
    /**
     * 
     * @type {string}
     * @memberof Scorecard
     */
    customerExternalId?: string;
    /**
     * 
     * @type {Date}
     * @memberof Scorecard
     */
    eventDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Scorecard
     */
    dateCreated?: Date;
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    progress?: number;
    /**
     * 
     * @type {ScorecardStatus}
     * @memberof Scorecard
     */
    status?: ScorecardStatus;
    /**
     * 
     * @type {string}
     * @memberof Scorecard
     */
    notes?: string;
    /**
     * 
     * @type {ScorecardOutcome}
     * @memberof Scorecard
     */
    outcome?: ScorecardOutcome;
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    contactCount?: number;
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    reviewerId?: number;
    /**
     * 
     * @type {string}
     * @memberof Scorecard
     */
    reviewerFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Scorecard
     */
    reviewerLastName?: string;
    /**
     * 
     * @type {number}
     * @memberof Scorecard
     */
    agentId?: number;
    /**
     * 
     * @type {string}
     * @memberof Scorecard
     */
    agentFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Scorecard
     */
    agentLastName?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Scorecard
     */
    properties?: { [key: string]: string; };
}

/**
 * Check if a given object implements the Scorecard interface.
 */
export function instanceOfScorecard(value: object): boolean {
    return true;
}

export function ScorecardFromJSON(json: any): Scorecard {
    return ScorecardFromJSONTyped(json, false);
}

export function ScorecardFromJSONTyped(json: any, ignoreDiscriminator: boolean): Scorecard {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'template': json['template'] == null ? undefined : ScorecardTemplateSummaryFromJSON(json['template']),
        'customerExternalId': json['customerExternalId'] == null ? undefined : json['customerExternalId'],
        'eventDate': json['eventDate'] == null ? undefined : (new Date(json['eventDate'])),
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'score': json['score'] == null ? undefined : json['score'],
        'progress': json['progress'] == null ? undefined : json['progress'],
        'status': json['status'] == null ? undefined : ScorecardStatusFromJSON(json['status']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'outcome': json['outcome'] == null ? undefined : ScorecardOutcomeFromJSON(json['outcome']),
        'contactCount': json['contactCount'] == null ? undefined : json['contactCount'],
        'reviewerId': json['reviewerId'] == null ? undefined : json['reviewerId'],
        'reviewerFirstName': json['reviewerFirstName'] == null ? undefined : json['reviewerFirstName'],
        'reviewerLastName': json['reviewerLastName'] == null ? undefined : json['reviewerLastName'],
        'agentId': json['agentId'] == null ? undefined : json['agentId'],
        'agentFirstName': json['agentFirstName'] == null ? undefined : json['agentFirstName'],
        'agentLastName': json['agentLastName'] == null ? undefined : json['agentLastName'],
        'properties': json['properties'] == null ? undefined : json['properties'],
    };
}

export function ScorecardToJSON(value?: Scorecard | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'template': ScorecardTemplateSummaryToJSON(value['template']),
        'customerExternalId': value['customerExternalId'],
        'eventDate': value['eventDate'] == null ? undefined : ((value['eventDate'] as any).toISOString()),
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'score': value['score'],
        'progress': value['progress'],
        'status': ScorecardStatusToJSON(value['status']),
        'notes': value['notes'],
        'outcome': ScorecardOutcomeToJSON(value['outcome']),
        'contactCount': value['contactCount'],
        'reviewerId': value['reviewerId'],
        'reviewerFirstName': value['reviewerFirstName'],
        'reviewerLastName': value['reviewerLastName'],
        'agentId': value['agentId'],
        'agentFirstName': value['agentFirstName'],
        'agentLastName': value['agentLastName'],
        'properties': value['properties'],
    };
}

